import Filter from '@/src/components/organism/Filter';
import { useEffect, useRef, useState } from 'react';
import { bannerFilters } from './filter';
import { useQuery } from '@tanstack/react-query';
import useQueryValues from '@/src/hooks/useQueryValues';
import MainContentTitle from '@/src/components/molecule/MainContentTitle';
import { AgGridReact } from 'ag-grid-react';
import Table from '@/src/components/atom/Table';
import { bannerListColumn } from './column';
import SectionCardNoneTitle from '@/src/components/molecule/SectionCardNoneTitle';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';
import LucideIcon from '@/src/components/atom/Icons/LucideIcon';
import usePaginationQuery from '@/src/hooks/usePaginationQuery';
import { NAV_CONST } from '@/src/constants/nav';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';
import {
  getBannerAPI,
  getBannerContentCatetoryAPI,
} from '@/src/apis/rest/banner';
import OrderModal from './components/OrderModal';

type ModalState = 'NONE' | 'ORDER';

export default function MainBannerListPage() {
  const navigate = useNavigate();

  const { defaultValues } = useQueryValues({
    createdAt: ['createdAtFrom', 'createdAtTo'],
  });
  const { page, pageSize, handlePageChange } = usePaginationQuery();

  const gridRef = useRef<AgGridReact>(null);
  const [values, setValues] = useState(defaultValues);
  const [modalState, setModalState] = useState<ModalState>('NONE');

  // query
  const { data: bannerContentCategoryOptions } = useQuery({
    queryKey: ['banner-content-category-options'],
    queryFn: getBannerContentCatetoryAPI,
    select: data =>
      (data?.rows || []).map(item => ({ label: item.value, value: item.key })),
  });
  const { data: orderBannerList, refetch: orderBannerListRefetch } = useQuery({
    queryKey: ['banners-order'],
    queryFn: () => {
      return getBannerAPI({
        bannerType: '홈 배너',
        orderByKey: 'bannerOrderNumber',
        page: 1,
        pageSize: 30,
        bannerShowedYn: true,
        isNowExposed: true,
      });
    },
  });

  console.log('orderBannerList >>>', orderBannerList);

  const {
    data: bannerListOrigin,
    isError,
    isFetching,
  } = useQuery({
    queryKey: ['banners', values, page, pageSize],
    queryFn: () => {
      return getBannerAPI({
        ...values,
        bannerType: '홈 배너',
        orderByKey: 'id',
        page,
        pageSize,
      });
    },
  });

  // event
  const handleOpenModal = (type: ModalState) => {
    setModalState(type);
  };
  const handleCloseModal = () => {
    setModalState('NONE');
  };
  const handleToggleModal = (type: ModalState) => {
    if (modalState === type) {
      handleCloseModal();
    } else {
      setModalState(type);
    }
  };

  // effect
  useEffect(() => {
    if (isFetching && gridRef.current) {
      gridRef.current.api?.showLoadingOverlay();
    }
  }, [isFetching]);

  return (
    <>
      <MainContentTitle
        pageTitle={NAV_CONST.mainBannerManagement}
        breadcrumbList={[NAV_CONST.mainBanner]}
      />
      <div className="mb-20 flex flex-col gap-6">
        <Filter
          title="검색 필터"
          filters={bannerFilters(bannerContentCategoryOptions || [])}
          onSubmit={values => {
            handlePageChange(1, pageSize, false);
            setValues(values);
          }}
        />
        <div className="flex flex-col gap-y-6">
          <SectionCardNoneTitle
            contentProps={{
              className: 'flex flex-col gap-y-4',
            }}
          >
            <div className="flex items-center justify-between">
              <Typo typoType="b18m">메인 배너 목록</Typo>
              <div className="flex gap-2">
                <Button
                  buttonSize="medium"
                  buttonColor="outline"
                  onClick={() => {
                    handleOpenModal('ORDER');
                  }}
                >
                  <div className="flex items-center gap-x-2 text-primary">
                    <LucideIcon name="List" color="primary" />
                    메인 배너 노출 순번 관리
                  </div>
                </Button>
                <Link to={PATH.MAIN_BANNER_CREATE}>
                  <Button buttonSize="medium">
                    <div className="flex items-center gap-x-2">
                      <LucideIcon name="Plus" color="white" />
                      배너 등록
                    </div>
                  </Button>
                </Link>
              </div>
            </div>

            <Table
              ref={gridRef}
              rowData={isError ? [] : bannerListOrigin?.rows || []}
              isPaginationDataMapping
              columnDefs={bannerListColumn(e => {
                navigate(PATH.MAIN_BANNER_DETAIL.replace(':id', String(e)));
              })}
              total={bannerListOrigin?.count || 0}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={handlePageChange}
            />
          </SectionCardNoneTitle>
        </div>
      </div>

      {/* 모달 */}
      {modalState === 'ORDER' && (
        <OrderModal
          open={modalState === 'ORDER'}
          onOpenChange={() => handleToggleModal('ORDER')}
          items={orderBannerList?.rows || []}
          onOkClick={() => {
            orderBannerListRefetch();
          }}
        />
      )}
    </>
  );
}
